module.exports = __webpack_public_path__ + "static/img/cont54 (2).1d3aed8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont54 (2).jpg
// module id = FZ51
// module chunks = 0